import React, { useEffect, useState } from "react";
import { MdModeEditOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Card from "components/card";
import { getCoursesApi } from "Services/allApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Courses = () => {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true); 
      try {
        const response = await getCoursesApi();
        if (response && !response.error) {
          setProjects(response.data);
          // toast.success("Courses loaded successfully!");
        } else {
          console.error("Failed to fetch courses:", response.message);
          toast.error("Failed to fetch courses!");
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
        toast.error("An unexpected error occurred!");
      }
      setLoading(false); 
    };
    fetchCourses();
  }, []);

  const handleEditClick = (id) => {
    navigate(`/admin/edit-courses/${id}`);
    toast.info("Navigating to edit course page...");
  };

  return (
    <>
      <Card extra={"w-full p-4 h-full"}>
        <div className="mb-8 w-full">
          <h4 className="text-xl font-bold text-navy-700 dark:text-white">
            All Courses
          </h4>
        </div>
        {loading ? (
          <p className="text-center text-purple-800">Loading courses...</p>
        ) : projects.length > 0 ? (
          projects.map((project, index) => (
            <div
              key={index}
              className="mb-3 flex w-full items-center justify-between rounded-2xl bg-white p-3 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none"
            >
              <div className="flex items-center">
                <div className="">
                  <img
                    className="h-[83px] w-[83px] rounded-lg"
                    src={project.image}
                    alt={project.main_title || "Course Image"}
                  />
                </div>
                <div className="ml-4">
                  <p className="text-base font-medium text-navy-700 dark:text-white">
                    {project.main_title}
                  </p>
                  <p className="mt-2 text-sm text-gray-600">
                    Rating : {project.raing}
                  </p>
                </div>
              </div>
              <div
                onClick={() => handleEditClick(project.id)}
                className="mr-4 flex items-center justify-center text-purple-500 hover:text-purple-800 cursor-pointer"  
              >
                <MdModeEditOutline size={22}  /> 
              </div>
            </div>
          ))
        ) : (
          <p className="text-center text-purple-800">No courses available.</p>
        )}
      </Card>
      <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop closeButton={true} />
    </>
  );
};

export default Courses;
